export const playerProfiles = [
  {
    id: 0,
    title: "player",
    subtitle: "registration_athlete_subtitle",
    usageprice: "registration_athlete_usageprice",
    maindescription: "registration_athlete_maindescription",
    subdescription: "",

    imageUrl: "/assets/images/avatar/avatar_1.jpg",
  },
];

export const partnerProfiles = [
  {
    id: 1,
    title: "i_am_coach",
    subtitle: "coach_registration_subtitle",
    usageprice: "coach_registration_usageprice",
    maindescription: "coach_registration_maindescription",
    subdescription: "coach_registration_subdescription",
    imageUrl: "/assets/images/whistle.png",
    identifier: "coach",
  },
  {
    id: 2,
    title: "i_own_club_facility",
    subtitle: "sportfacility_registration_subtitle",
    usageprice: "sportfacility_registration_usageprice",
    maindescription: "sportfacility_registration_maindescription",
    subdescription: "sportfacility_registration_subdescription",
    imageUrl: "/assets/images/court.png",
    identifier: "facility",
  },

  {
    id: 3,
    title: "tournamentorganiser_registration",
    subtitle: "tournamentorganiser_registration_subtitle",
    usageprice: "tournamentorganiser_registration_usageprice",
    maindescription: "tournamentorganiser_registration_maindescription",
    subdescription: "tournamentorganiser_registration_subdescription",
    imageUrl: "/assets/images/medal_first.png",
    identifier: "organiser",
  },
];

// export const partnerProfiles = [
//   {
//     id: 1,
//     title: "Edző, oktató",
//     subtitle: "Személyi edzők, egyéni edzők számára. Bővítsd ügyfélköröd!",
//     usageprice: "Alapdíj: 3000 Ft / hó + egyedi díjas extra funkciók",
//     mainDescription: "Online naptár, bérletkezelés, lemondások",
//     subDescription: "Adminisztrálj mindent egy helyen.",
//     imageUrl: "/assets/images/whistle.png",
//   },
//   {
//     id: 2,
//     title: "Sportlétesítmény",
//     subtitle:
//       "Sportpálya üzemeltetőknek (sportklub, egyesület, sport-és szabadidőközpont, konditerem)",
//     usageprice: "2000 Ft / pálya / hó  + egyedi díjas extra funkciók",
//     mainDescription:
//       "Online naptár, bérletek, online fizetés, tag nyilvántartás",
//     subDescription: "Adminisztrálj mindent egy helyen.",
//     imageUrl: "/assets/images/court.png",
//   },

//   {
//     id: 3,
//     title: "Versenyszervező",
//     subtitle:
//       "Versenyeket, kupákat, tornákat, bajnokságokat szervezel? Válaszd a szerepkört és emeld profi szintre a szervezést!",
//     usageprice: "Egyedi árazás sportáganként",
//     mainDescription: "Online versenyszervezés könnyedén",
//     subDescription:
//       "Jelentkezés, sorsolás, játékrend, eredmények, rangsorok - minden egy rendszerben",
//     imageUrl: "/assets/images/medal_first.png",
//   },
// ];
